/* vm-course-waitlist.js
   Zweck:   Nach erfolgreichem Eintrag (?vm_waitlist=<kurs> oder ?customer_posted=true) Erfolgszustand zeigen.
   Basis:   Concept 6.0.x — Custom Element, kein globaler State
   Deps:    sections/vm-course-waitlist.liquid, assets/vm-course.css
*/
class VmCourseWaitlist extends HTMLElement {
  connectedCallback() {
    let params = null;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    const key = params.get('vm_waitlist');
    const posted = params.get('customer_posted') === 'true';
    if (!(key && key === this.dataset.vmCourse) && !posted) return;
    this.classList.add('is-success');
    const msg = this.querySelector('[data-vm-waitlist-success]');
    if (msg) { msg.hidden = false; msg.setAttribute('role', 'status'); }
  }
}
if (!customElements.get('vm-course-waitlist')) customElements.define('vm-course-waitlist', VmCourseWaitlist);
